<template>
  <div class="allocation-records">
    <el-card>
      <template #header>
        <div class="card-header">
          <span>分配记录查询</span>
          <el-button type="primary" @click="exportRecords">导出记录</el-button>
        </div>
      </template>
      
      <el-form :inline="true" :model="searchForm" style="margin-bottom: 20px">
        <el-form-item label="用户ID">
          <el-input v-model="searchForm.userId" placeholder="请输入用户ID" />
        </el-form-item>
        <el-form-item label="任务ID">
          <el-input v-model="searchForm.taskId" placeholder="请输入任务ID" />
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="searchForm.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="loadRecords">查询</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="records" border stripe>
        <el-table-column prop="id" label="ID" width="60" />
        <el-table-column prop="taskId" label="任务ID" width="80" />
        <el-table-column prop="userId" label="用户ID" width="80" />
        <el-table-column prop="taskSource" label="任务来源" width="100">
          <template #default="{ row }">
            <el-tag>{{ row.taskSource }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="totalAmount" label="总金额" width="100">
          <template #default="{ row }">
            {{ row.totalAmount }}元
          </template>
        </el-table-column>
        <el-table-column label="现金分(60%)" width="100">
          <template #default="{ row }">
            <el-tag type="success">{{ row.allocationResult?.debtorIncome || 0 }}元</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="解债分(30%)" width="100">
          <template #default="{ row }">
            <el-tag type="warning">{{ row.allocationResult?.debtRepayment || 0 }}元</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="平台收入(10%)" width="100">
          <template #default="{ row }">
            <el-tag type="danger">{{ row.allocationResult?.platformFee || 0 }}元</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="分配时间" width="180" />
      </el-table>

      <el-pagination
        v-model:current-page="pagination.page"
        v-model:page-size="pagination.pageSize"
        :total="pagination.total"
        :page-sizes="[20, 50, 100]"
        layout="total, sizes, prev, pager, next"
        @size-change="loadRecords"
        @current-change="loadRecords"
        style="margin-top: 20px; justify-content: flex-end"
      />
    </el-card>

    <!-- 统计卡片 -->
    <el-row :gutter="20" style="margin-top: 20px">
      <el-col :span="6">
        <el-card shadow="hover">
          <el-statistic title="总分配次数" :value="stats.totalCount">
            <template #suffix>次</template>
          </el-statistic>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover">
          <el-statistic title="总分配金额" :value="stats.totalAmount" prefix="¥">
            <template #suffix>元</template>
          </el-statistic>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover">
          <el-statistic title="总还债金额" :value="stats.totalDebtRepayment" prefix="¥">
            <template #suffix>元</template>
          </el-statistic>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover">
          <el-statistic title="平台总收入" :value="stats.totalPlatformFee" prefix="¥">
            <template #suffix>元</template>
          </el-statistic>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { ElMessage } from 'element-plus';

const records = ref([]);
const searchForm = reactive({
  userId: '',
  taskId: '',
  dateRange: [],
});
const pagination = reactive({
  page: 1,
  pageSize: 20,
  total: 0,
});
const stats = reactive({
  totalCount: 0,
  totalAmount: 0,
  totalDebtRepayment: 0,
  totalPlatformFee: 0,
});

const loadRecords = async () => {
  // 这里应该调用后端API获取分配记录
  // 暂时使用模拟数据
  records.value = [
    {
      id: 1,
      taskId: 1001,
      userId: 123,
      taskSource: 'platform',
      totalAmount: 100,
      allocationResult: {
        debtorIncome: 60,
        debtRepayment: 30,
        platformFee: 10,
      },
      createdAt: '2024-03-12 10:30:00',
    },
  ];
};

const exportRecords = () => {
  ElMessage.info('导出功能开发中...');
};

onMounted(() => {
  loadRecords();
});
</script>

<style scoped>
.allocation-records {
  padding: 20px;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
